// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`TemplateCategory model belongsTo relations 1`] = `
Array [
  "Scope",
]
`;

exports[`TemplateCategory model hasMany relations 1`] = `
Array [
  "SpecCategory",
]
`;
